// extracted by mini-css-extract-plugin
module.exports = {"main":"sk-CardCoverImage_main__sXQ31"};